import React from "react";

export const EquilateralTriangle = ({
  size,
  color,
  borderWidth,
  borderColor,
}) => {
  const svgPoints = [
    `${-size / 2}, ${size / 2}`,
    `${size / 2}, ${size / 2}`,
    `${0}, ${-size / 2}`,
  ];
  let points = svgPoints.join(",");
  return (
    <g>
      <polygon
        points={svgPoints.join(" ")}
        fill={color}
        stroke={borderColor}
        strokeWidth={borderWidth}
        style={{ pointerEvents: "none" }}
      />
    </g>
  );
};
